module.exports = __webpack_public_path__ + "static/media/3-1.725d9e59.jpg";